import styles from "./ErrorPage.module.scss";
import mainImage from "../../assets/images/error-page/main-image.png";
import { useTranslation } from "react-i18next";

const ErrorPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <img className={styles.image} src={mainImage} alt={t("WeHaveEncounteredProblem")} />
      <h2 className={styles.title}>{t("WeHaveEncounteredProblem")}</h2>
      <p className={styles.description}>{t("FunctionalityThisPageIsCurrentlyDisrupted")}</p>
    </div>
  );
};

export default ErrorPage;
